const rawVersion = (process.env.REACT_APP_APP_VERSION || "").trim();

export const APP_VERSION = rawVersion;

export const APP_VERSION_SHORT = rawVersion ? `v${rawVersion}` : "local";

export const APP_VERSION_LABEL = rawVersion
  ? `Version ${rawVersion}`
  : "Local build";
